import { memo } from "react";
import { useTranslation } from "react-i18next";
import Spinner from "@/components/Spinner";
import ConfirmDialog from "@/components/confirm-dialog/ConfirmDialog";
import { Button } from "@/components/ui/button";
import { useRowSelectionCount } from "@/components/data-table/hooks/useRowSelectionCount";
import { OperationProgressStatus } from "@/components/progress";

interface PayrollCreateEntrySubmitButtonProps {
  onConfirm: () => void;
  isPending: boolean;
  progressStatus: OperationProgressStatus;
}

const PayrollCreateEntrySubmitButtonComponent = ({
  onConfirm,
  isPending,
  progressStatus,
}: PayrollCreateEntrySubmitButtonProps) => {
  const { t } = useTranslation();
  const selectedCount = useRowSelectionCount();

  return (
    <ConfirmDialog
      title={t("payrolls.createEntryDialog.confirmTitle")}
      content={t("payrolls.createEntryDialog.confirmDescription", {
        count: selectedCount,
      })}
      yesLabel={t("payrolls.createEntryDialog.createButton")}
      noLabel={t("payrolls.createEntryDialog.cancelButton")}
      onConfirm={onConfirm}
    >
      <Button
        disabled={
          selectedCount === 0 ||
          isPending ||
          progressStatus !== OperationProgressStatus.IDLE
        }
      >
        {isPending && <Spinner className="w-4 h-4 mr-2" />}
        {t("payrolls.createEntryDialog.nextButton")}
      </Button>
    </ConfirmDialog>
  );
};

export const PayrollCreateEntrySubmitButton = memo(
  PayrollCreateEntrySubmitButtonComponent,
);
